/**
* Created For: 输入终端名称筛选   this.$emit("searchHandle",val)
* Author: chenLiYan.
* Date: 2018/12/3 0003 21:19.
*/
<template>
  <transition name="page-move">
    <div class="client-filter-page flex-wrap flex-vertical" v-if="isShow">
      <v-title title="终端搜索" :isShowBack="true" :isDefaultBack="false" @backHandle="hide()"></v-title>
      <!--搜索输入框-->
      <form action="javascript:return true" class="search-box flex-none">
        <search-bar
          ref="keywordInput"
          placeholder="输入终端名称"
          :isFocus="true"
          :defaultVal="curClientName"
          @enter="searchHandle">
        </search-bar>
      </form>
      <!--历史搜索记录-->
      <template v-if="hisSearchList.length>0">
        <div class="history-title flex-none">历史记录</div>
        <ul class="history-ul">
          <li v-for="keyword in hisSearchList" :key="keyword" @click="searchHandle(keyword)">{{ keyword }}</li>
        </ul>
      </template>
    </div>
  </transition>

</template>

<script>
import SearchBar from './_search_bar.vue'
export default {
  name: 'ClientNameFilter',
  components: { SearchBar },
  props: {
    // 终端名称
    clientName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isShow: false,
      curClientName: this.clientName
    }
  },
  computed: {
    // 历史搜索列表
    hisSearchList () {
      return this.$store.state.localSt.historySearch
    }
  },
  beforeMount () {},
  methods: {
    show () {
      this.curClientName = this.clientName
      this.isShow = true
    },
    hide () {
      this.isShow = false
    },
    // 回车提交事件
    searchHandle (val) {
      if (val) {
        // 存储为历史搜索
        this.$store.commit('SetHistorySearch', val)
        // 触发搜索
        this.$emit('searchHandle', val)
        this.hide()
      } else {
        // 触发搜索
        this.$emit('searchHandle', val)
        this.hide()
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
    @import "../../stylus/base/base.styl";
    .client-filter-page {
        width 100%
        height 100%
        position fixed
        top: 0
        left 0
        z-index 91
        background #fff
        transform: translate(0, 0)
        .search-box{
            padding 12px 32px
            box-shadow 0 5px 10px rgba(0,0,0,.1)
            margin-bottom 8px
            margin-top 90px
        }
        .history-title{
            margin 20px 0 0 32px
            line-height 60px
            border-bottom 1px solid $border-color
            font-size $font-M
            color $color-font-lighter
        }
        .history-ul{
            margin-left 32px
            overflow auto
            li{
                padding 24px 32px 24px 0
                line-height 40px
                font-size $font-XXL
                font-weight bold
                border-bottom 1px solid $border-color
            }
        }
    }
    // 过渡效果
    .page-move-enter, .page-move-leave-active
        transform: translate(100%, 0)
    .page-move-enter-active, .page-move-leave-active
        transition: transform .3s
</style>
